import { REPORTS_DEFAULT_FILTERS } from '@constants/Reports/reportsDefaultToolbar.constants'

export const FAMILY_OPPORTUNITY_FILTERS = REPORTS_DEFAULT_FILTERS

export const FAMILY_OPPORTUNITY_KPI_DEFINITIONS: Array<{
  id: string
  title: string
  footer: string
  unitInline?: string
  footerMode?:
    | 'percentChange'
    | 'pointChange'
    | 'percentOfPriorBase'
    | 'descriptor'
  footerDescriptor?: string
}> = [
  {
    id: 'same-family',
    title: 'Same-family opportunities',
    unitInline: 'patients',
    footer: '',
    footerMode: 'percentChange',
  },
  {
    id: 'household-gaps',
    title: 'Households with gaps',
    unitInline: 'families',
    footer: '',
    footerMode: 'percentChange',
  },
  {
    id: 'birthdays',
    title: 'Upcoming birthdays/milestones (30 days)',
    unitInline: 'patients',
    footer: '',
    footerMode: 'descriptor',
    footerDescriptor: 'Outreach list',
  },
  {
    id: 'multi-family-gaps',
    title: 'Multi-family scheduling gaps',
    unitInline: 'gaps',
    footer: '',
    footerMode: 'percentChange',
  },
]

/** Same-Family Opportunities — chart category labels (Overdue Recall excluded). */
export const SAME_FAMILY_CATEGORY_LABELS = [
  'Unscheduled Tx',
  'Hygiene Gap',
  'Unscheduled Member',
] as const

/** Multi-family scheduling gap — spread across date bands. */
export const MULTI_FAMILY_GAP_BUCKET_LABELS = [
  '0-7 days',
  '8-14 days',
  '15-30 days',
  '31-60 days',
  '60+ days',
] as const

export type BirthdayMilestoneRow = {
  id: string
  patientName: string
  date: string
  household: string
}

export type HouseholdSchedulingGapRow = {
  id: string
  household: string
  members: string
  dueUnscheduled: string
}
